"use client";

import { Flex } from "@chakra-ui/react";
import { EmptyState } from "@/components/feedback";
import { Button, Text } from "@/components/ui";

interface TermsPageErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const TermsPageError = ({
  onRetry,
  isRetrying = false,
}: TermsPageErrorProps) => {
  return (
    <EmptyState
      title="Couldn't load waivers"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            Something went wrong while fetching policies and waivers. Please try again.
          </Text>
          <Button
            variant="primary"
            size="sm"
            data-testid="terms-page-retry-button"
            onClick={onRetry}
            isLoading={isRetrying}
            isDisabled={isRetrying}
          >
            Try again
          </Button>
        </Flex>
      }
    />
  );
};
